(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lunvelis-slide-commit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lv-slide-commit')) {
    customElements.define('lv-slide-commit', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.form = this.closest('form');
        this.track = this.querySelector('.lv-slide-track');
        this.handle = this.querySelector('.lv-slide-handle');
        this.fallback = this.querySelector('.lv-slide-fallback');
        this.label = this.querySelector('.lv-slide-label');
        this.status = this.querySelector('.lv-slide-status');
        this.cartLink = this.querySelector('.lv-slide-cart-link');
        if (!this.form || !window.fetch || !window.PointerEvent) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track.hidden = false;
        this.setAttribute('data-ready', '');
        this.state('idle');
        this.handle.addEventListener('pointerdown', event => {
          if (this.locked || this.handle.disabled || !event.isPrimary || event.button !== 0) return;
          this.pointer = event.pointerId;
          this.origin = event.clientX;
          this.travel = Math.max(0, this.track.clientWidth - this.handle.offsetWidth - 10);
          this.progress = 0;
          this.handle.setPointerCapture(event.pointerId);
          this.setAttribute('data-dragging', '');
        }, options);
        this.handle.addEventListener('pointermove', event => {
          if (event.pointerId !== this.pointer) return;
          this.progress = this.travel ? Math.min(1, Math.max(0, (event.clientX - this.origin) / this.travel)) : 0;
          this.position(this.progress);
        }, options);
        this.handle.addEventListener('pointerup', event => {
          if (event.pointerId !== this.pointer) return;
          const commit = this.progress >= .9;
          this.cancelDrag();
          if (commit) this.submit();
        }, options);
        for (const name of ['pointercancel', 'lostpointercapture']) this.handle.addEventListener(name, () => this.cancelDrag(), options);
        this.handle.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.cancelDrag();
        }, options);
        this.handle.addEventListener('click', event => {
          event.preventDefault();
          if (event.detail === 0) this.submit();
        }, options);
        this.form.addEventListener('submit', event => {
          event.preventDefault();
          if (!this.locked && !this.fallback.disabled) this.add();
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        clearTimeout(this.resetTimer);
      }
      position(progress) {
        const travel = Math.max(0, this.track.clientWidth - this.handle.offsetWidth - 10);
        this.style.setProperty('--lv-slide-x', `${progress * travel}px`);
        this.style.setProperty('--lv-slide-progress', progress);
      }
      cancelDrag() {
        const pointer = this.pointer;
        this.pointer = null;
        if (pointer != null && this.handle.hasPointerCapture(pointer)) this.handle.releasePointerCapture(pointer);
        this.removeAttribute('data-dragging');
        if (!this.locked) this.position(0);
      }
      submit() {
        if (this.locked || this.fallback.disabled) return;
        this.form.requestSubmit(this.fallback);
      }
      state(value) {
        this.dataset.state = value;
        const unavailable = this.hasAttribute('data-unavailable-product');
        this.label.textContent = unavailable ? this.dataset.unavailable : ({ busy: this.dataset.busy, success: this.dataset.done, error: this.dataset.error, uncertain: this.dataset.error }[value] || this.dataset.label);
        this.handle.firstElementChild.textContent = value === 'success' ? '✓' : value === 'busy' ? '…' : '→';
      }
      async refreshCart() {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(15000) });
        if (!response.ok) throw new Error('cart');
        const cart = await response.json();
        document.querySelectorAll('[data-cart-count]').forEach(node => { node.textContent = cart.item_count; });
        const drawer = document.querySelector('#CartDrawer');
        const target = document.querySelector('#CartDrawerContent');
        if (!drawer?.showModal || !target) return;
        const preview = await fetch(`${root}cart?section_id=cart-preview`, { headers: { Accept: 'text/html' }, signal: AbortSignal.timeout(15000) });
        if (!preview.ok) throw new Error('preview');
        const html = new DOMParser().parseFromString(await preview.text(), 'text/html');
        const content = html.querySelector('.shopify-section');
        if (!content) throw new Error('preview');
        target.replaceChildren(...content.childNodes);
        drawer.addEventListener('close', () => { if (this.isConnected) this.handle.focus(); }, { once: true });
        if (!drawer.open) drawer.showModal();
      }
      async add() {
        if (this.locked) return;
        const payload = new FormData(this.form);
        this.locked = true;
        this.handle.disabled = true;
        this.fallback.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        this.cartLink.hidden = true;
        this.state('busy');
        this.position(1);
        let confirmed = false;
        let uncertain = false;
        try {
          const root = window.Shopify?.routes?.root || '/';
          let response;
          let result;
          try {
            response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: payload, signal: AbortSignal.timeout(20000) });
            if (response.ok) confirmed = true;
            result = await response.json();
          } catch {
            if (!confirmed) uncertain = true;
          }
          if (!confirmed) {
            if (!response || response.status >= 500) uncertain = true;
            this.state(uncertain ? 'uncertain' : 'error');
            this.position(0);
            this.status.textContent = uncertain ? this.dataset.uncertain : (result?.description || result?.message || this.dataset.error);
            this.cartLink.hidden = !uncertain;
            return;
          }
          this.state('success');
          this.status.textContent = `${this.dataset.product}: ${this.dataset.done}`;
          this.cartLink.hidden = false;
          try { await this.refreshCart(); } catch { this.cartLink.focus(); }
          this.resetTimer = setTimeout(() => {
            this.state('idle');
            this.position(0);
            this.locked = false;
            this.handle.disabled = false;
            this.fallback.disabled = false;
          }, 1500);
        } finally {
          this.form.removeAttribute('aria-busy');
          if (!confirmed && !uncertain) {
            this.locked = false;
            this.handle.disabled = false;
            this.fallback.disabled = false;
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
